<template>
  <div class="Crisis_addmajor_event">

    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="学生学号" prop="xuehao">
        <el-input v-model="ruleForm.xuehao"></el-input>
      </el-form-item>

      <el-form-item label="学生姓名" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <el-form-item label="心理辅导员" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <el-form-item label="谈话时间" prop="name">
        <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="谈话地点" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">问题备注及应对工作（ <i style="color: red;">*</i> 为必填项）</h2>

      <el-form-item class="quz" label="初评危机状态">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="红色预警" name="type"></el-checkbox>
          <el-checkbox label="橙色预警" name="type"></el-checkbox>
          <el-checkbox label="黄色预警" name="type"></el-checkbox>
          <el-checkbox label="蓝色预警" name="type"></el-checkbox>
          <el-checkbox label="绿色预警" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">问题备注及应对工作（ <i style="color: red;">*</i> 为必填项）</h2>

      <el-form-item class="bgfbf" label="初评危机状态" prop="xuehao">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="自杀伤人倾向" name="type"></el-checkbox>
          <el-checkbox label="重性精神病" name="type"></el-checkbox>
          <el-checkbox label="应激危机" name="type"></el-checkbox>
          <el-checkbox label="人格问题" name="type"></el-checkbox>
          <el-checkbox label="情绪障碍" name="type"></el-checkbox>
          <el-checkbox label="成瘾行为" name="type"></el-checkbox>
          <el-checkbox label="进食问题" name="type"></el-checkbox>
          <el-checkbox label="睡眠问题" name="type"></el-checkbox>
          <el-checkbox label="其他" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="hjoi" label="严重情况突出表现" prop="tubx">
        <el-checkbox-group @change="tcbx()" v-model="ruleForm.tubx">
          <el-checkbox label="自杀、自伤或伤害他人倾向" name="type"></el-checkbox>
          <el-checkbox label="疑似重性精神病" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div v-if="pdtcbx">
        <h3 style="font-size: 16px;margin-left: 20px;padding-bottom: 20px;">自杀、自伤或伤害他人倾向详情</h3>

        <el-form-item label="发生时间">
          <el-date-picker v-model="value1"  type="date" placeholder="选择日期"> </el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>

        <el-form-item class="bgfbf" label="关于伤害的情况">
          <el-checkbox-group v-model="ruleForm.type">
            <el-checkbox label="自杀想法" name="type"></el-checkbox>
            <el-checkbox label="自杀计划" name="type"></el-checkbox>
            <el-checkbox label="自杀未遂" name="type"></el-checkbox>
            <el-checkbox label="自杀实施中" name="type"></el-checkbox>
            <el-checkbox label="自杀姿态" name="type"></el-checkbox>
            <el-checkbox label="被动自杀" name="type"></el-checkbox>
            <el-checkbox label="自伤自残" name="type"></el-checkbox>
            <el-checkbox label="伤害他人" name="type"></el-checkbox>
            <el-checkbox label="扩大性自杀" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>

      <div v-if="pdtcbx2">

        <h3 style="font-size: 16px;margin-left: 20px;padding-bottom: 20px;">疑似重性精神病详情</h3>

        <el-form-item label="发生时间">
          <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>

        <el-form-item class="bgfbf" label="疑似出现">
          <el-checkbox-group v-model="ruleForm.type">
            <el-checkbox label="感知觉障碍" name="type"></el-checkbox>
            <el-checkbox label="思维障碍" name="type"></el-checkbox>
            <el-checkbox label="注意障碍" name="type"></el-checkbox>
            <el-checkbox label="记忆障碍" name="type"></el-checkbox>
            <el-checkbox label="定向力障碍" name="type"></el-checkbox>
            <el-checkbox label="情感障碍" name="type"></el-checkbox>
            <el-checkbox label="意志障碍" name="type"></el-checkbox>
            <el-checkbox label="动作与行为障碍" name="type"></el-checkbox>
            <el-checkbox label="意识障碍" name="type"></el-checkbox>
            <el-checkbox label="自知力缺失" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

      </div>

      <el-form-item class="bgssfbf" label="心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况日期">
        <el-date-picker v-model="value1"  type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>

      <el-form-item label="地点">
        <el-input v-model="ruleForm.xuehao"></el-input>
      </el-form-item>

      <el-form-item label="主要内容">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item label="上报领导">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="详情">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item label="与家长沟通">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="详情">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item label="就医情况">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="医院">
        <el-input v-model="ruleForm.xuehao"></el-input>
      </el-form-item>

      <el-form-item label="诊断结果">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item class="huhxs" label="是否推荐去心理中心">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item class="huhxsxs" label="后续是否实际去了">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item class="aaa1" label="心理联络员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item class="aaa2" label="心理委员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item class="bgfbf" label="心理中心建议">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="精神专科就医" name="type"></el-checkbox>
          <el-checkbox label="心理咨询" name="type"></el-checkbox>
          <el-checkbox label="心理危机干预" name="type"></el-checkbox>
          <el-checkbox label="保密突破联系监护人" name="type"></el-checkbox>
          <el-checkbox label="报警急救" name="type"></el-checkbox>
          <el-checkbox label="严密守护" name="type"></el-checkbox>
          <el-checkbox label="密切陪护" name="type"></el-checkbox>
          <el-checkbox label="重点关注" name="type"></el-checkbox>
          <el-checkbox label="适当关注" name="type"></el-checkbox>
          <el-checkbox label="绿色预警交流" name="type"></el-checkbox>
          <el-checkbox label="其他" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="iuho" label="当前学生危机状态">
        红色预警
      </el-form-item>

      <el-form-item class="iuho" label="是否调整危机状态">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </el-form-item>

      <el-form-item class="hkl" label="调整后危机状态">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="红色预警" name="type"></el-checkbox>
          <el-checkbox label="橙色预警" name="type"></el-checkbox>
          <el-checkbox label="黄色预警" name="type"></el-checkbox>
          <el-checkbox label="蓝色预警" name="type"></el-checkbox>
          <el-checkbox label="绿色预警" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>

    </el-form>

  </div>

</template>
<script>

export default {
  data() {
    return {
      pdtcbx: false,
      pdtcbx2: false,
      radio: '1',
      ruleForm: {
        xuehao: '',
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        tubx: [],
      },
      rules: {
        name: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        xuehao: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ],
        xuehao:[
          { type: 'array', required: true, message: '初评危机状态', trigger: 'change' }
        ],
        tubx: [
          { type: 'array', required: true, message: '请选择突出表现！', trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    tcbx() {
      if (this.ruleForm.tubx.length == 1) {
        if (this.ruleForm.tubx[0] == "自杀、自伤或伤害他人倾向") {
          this.pdtcbx = true;
        } else if (this.ruleForm.tubx[0] == "疑似重性精神病") {
          this.pdtcbx2 = true;
        }
      } else if (this.ruleForm.tubx.length == 2) {
        this.pdtcbx = true;
        this.pdtcbx2 = true;
      } else {
        this.pdtcbx = false;
        this.pdtcbx2 = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

  },
  mounted() {

  }
}
</script>

<style>

  .Crisis_addmajor_event{width: 100%;background-color: rgb(255, 255, 255);}
  .Crisis_addmajor_event .el-input{width: 240px;}
  .Crisis_addmajor_event .quz .el-form-item__content{margin-left: 20px !important;}
  .Crisis_addmajor_event .bgfbf .el-form-item__label{width: 150px !important;}
  .Crisis_addmajor_event .hjoi .el-form-item__label{width: 180px !important;}
  .Crisis_addmajor_event .bgssfbf .el-form-item__label{width: 492px !important;}
  .Crisis_addmajor_event .huhxs .el-form-item__label{width: 172px !important;}
  .Crisis_addmajor_event .huhxsxs .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .iuho .el-form-item__label{width: 156px !important;}
  .Crisis_addmajor_event .hkl .el-form-item__label{width: 146px !important;}

</style>